import useGet from '../../../../hooks/useGet'
import {
    getProductManufacturerCode,
    getProductName,
    getProductPresentationAmount
} from '../../../../utilities/productDisplay'
import {
    formInputPart,
    productsControl,
    reqProducts,
    storagePage
} from '../../storage'
import { LogicalProductData } from '../../types'
import { Option as OptionType } from '../../../../config/types/component'
import { render } from 'redity'
import { Empty, FormControl } from '../../../../components/FormUtilities'
import SearchResults from '../../../../components/SearchResult'
import Option from '../../../../components/Option'

let value = ''

export default function SearchProducts() {
    const { props } = formInputPart.useSelects('products')
    const { loading, data } = useGet<LogicalProductData[]>(
        reqProducts.observer(
            '/v5.6/apis/logical_products/logical_products_to_move?limit=10&sort=product_name&order=asc&type_order_operation_id=2',
            storagePage.mode === 'edition'
        ),
        []
    )

    function handleSelect(nextOptions: OptionType[]) {
        props.onChange(nextOptions)
        if (nextOptions.length === 0) {
            productsControl.setList([])
            reqProducts.deleteQuery('not_logical_product_ids')
            reqProducts.load()
            productsControl.renderMain()
            return
        }

        productsControl.mapping(lProduct => {
            if (
                !nextOptions.find(
                    option =>
                        parseInt(option.value) === lProduct.logical_product_id
                )
            ) {
                return null
            }
            return lProduct
        })

        nextOptions.forEach(option => {
            const productId = parseInt(option.value)
            if (
                productsControl
                    .getDataList()
                    .find(
                        _lProduct => _lProduct.logical_product_id === productId
                    )
            ) {
                return
            }

            const logicalProduct = data.result.find(
                _lProduct => productId === _lProduct.id
            )
            productsControl.push(
                {
                    logical_product_id: logicalProduct.id,
                    name: getProductName(logicalProduct.product),
                    code: getProductManufacturerCode(logicalProduct.product),
                    presentation: getProductPresentationAmount(
                        logicalProduct.product
                    ),
                    quantity: '',
                    stock: logicalProduct.max_quantity_to_move,
                    average: logicalProduct.operation
                        ? logicalProduct.operation.average_unit_cost.toFixed(2)
                        : '',
                    total: 0
                },
                false
            )
        })

        const ids = productsControl
            .getDataList()
            .map(lprod => lprod.logical_product_id)

        reqProducts.setQuery('not_logical_product_ids', ids)

        productsControl.renderMain()
    }

    function handleChange(ev) {
        value = ev.target.value
        if (value === '') {
            reqProducts.deleteQuery('search')
        } else {
            reqProducts.setQuery('search', value)
        }
        reqProducts.load()
        render(formInputPart.keyRender, 'traspase_products')
    }

    return (
        <FormControl label="Productos" col="span-4" required>
            <SearchResults
                disabled={props.disabled === undefined ? true : props.disabled}
                helper={props.helper}
                options={props.options}
                loading={loading}
                onChange={handleChange}
                onSelect={handleSelect}
                placeholder="Seleccionar productos"
                label="Productos"
                value={value}
            >
                {data.result.map(logicalProduct => (
                    <Option
                        key={logicalProduct.id}
                        value={logicalProduct.id.toString()}
                        label={getProductName(logicalProduct.product)}
                        label2={getProductManufacturerCode(
                            logicalProduct.product
                        )}
                    />
                ))}
                <Empty data={data.result} />
            </SearchResults>
        </FormControl>
    )
}
